import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/campaign/:id/:isPreview',
      name: 'land',
      component: () => import('./views/Land/index'),
      meta: { title: '风格展示' }
    },
    {
      path: '/campaign/editPreview',
      name: 'editPreview',
      component: () => import('./views/Land/index'),
      meta: { title: '风格展示', isEdit: true }
    },
    {
      path: '/empty/:type',
      name: 'empty',
      component: () => import('./views/Empty/index'),
      props: true,
      meta: { title: '风格展示' }
    },
  ]
})

export default router
